import { Box, Button, IconButton, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { AppLinks, pxToRem } from "@/util";
import { AppColors } from "@/assets/colors";
type props = {
  handleClose: () => void;
};
const navLinks: { name: string; link: string }[] = [
  { name: "Home", link: AppLinks.PUBLIC.HOME },
  { name: "Listing", link: AppLinks.PUBLIC.LISTINGS },
  { name: "Portfolio", link: AppLinks.PUBLIC.PORTFOLIOS },
  // { name: "Investment", link: AppLinks.PUBLIC.INVESTMENTS },
  { name: "Services", link: AppLinks.PUBLIC.SERVICES },
  { name: "About Us", link: AppLinks.PUBLIC.ABOUT },
  { name: "Contact us", link: AppLinks.PUBLIC.CONTACT },
  { name: "Book Consultation", link: AppLinks.PUBLIC.CONSULTATION },
];

export default function MobileNav({ handleClose }: props) {
  const { classes } = styles();

  return (
    <Box className={classes.container}>
      <Box className={classes.clearCont}>
        <IconButton className={classes.clearBtn} onClick={() => handleClose()}>
          <CloseRoundedIcon className={classes.clearIcon} />
        </IconButton>
      </Box>
      <Box className={classes.actCont}>
        {navLinks.map((value) => {
          return (
            <Button
              href={value.link}
              key={value.name}
              fullWidth
              className={classes.btn}
            >
              <Typography className={classes.desc}>{value.name}</Typography>
            </Button>
          );
        })}
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(2),
    minWidth: pxToRem(334),
    [theme.breakpoints.up(966)]: {
      display: "none",
    },
  },
  btn: {
    display: "flex",
    justifyContent: "flex-start",
  },
  desc: {
    fontWeight: 400,
    fontSize: pxToRem(18),
    color: AppColors.primary["600"],
  },
  clearCont: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  clearBtn: {
    display: "flex",
    padding: 12, // Increase padding
    width: 56,
    height: 56,
  },
  clearIcon: {
    fontSize: "2.5rem",
    color: `#323232`,
  },
  actCont: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
}));
